module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cl":{"reviewable":"Revisable","refused":"Rechazado","approved":"Aprobado","future":"Futura","immediate":"Inmediata"}}')
  delete Component.options._Ctor
}
